import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useParams } from "react-router-dom";
import LinesEllipsis from 'react-lines-ellipsis'
import { createTemplate, deleteTemplate, fetchCatgeoriesAndIndustries, fetchTemplates, updateTemplate, updateTemplateVisibility } from "actions/templates";
import { useIntercom } from 'react-use-intercom';

import _ from 'lodash';
import cx from 'classnames';

import { getBaseUrl } from "services/util";

import {
  Row,
  Col,
  Offcanvas,
  Dropdown,
  Form,
  Button,
  Image, 
  Popover, 
  OverlayTrigger, 
  ListGroup,
  Modal
} from "react-bootstrap";



import { IKImage } from "imagekitio-react";
import { Loader } from "components/ApplicationLoader";
import Tooltip from "components/Tooltip";
import InfiniteScroll from "components/InfiniteScroll";
import CreatableSelect from 'react-select/creatable';

import styles from './template.module.scss';
import { getPageViewedEventPayload } from "services/mixpanelUtil";
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_TEMPLATES, MIXPANEL_PAGE_VIEWED_MY_STORYBOARD } from "constants/mixpanelEvents";
import { createMixpanelEvent } from "actions/mixpanel";
import userRoleService from "services/userRoles.service";
import { PPTXButton } from "../pptxButton";

const INTERCOM_ID = process.env.REACT_APP_CLEVERSTORY_INTERCOM_ID;

const defaultTemplate = {
  selected: false,
  name: "Untitled-1",
  categories: [],
  industries: []
}

export const CreateStoryboard = ({ show, onClose, create, update, updateProperty, setPptState, setCreateState, storyboardState, setStoryboardState }) => {
  const dispatch = useDispatch();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const {listId} = useParams();

  const storyboard = useSelector(state => _.get(state, 'storyboards.storyboard.item', {}));
  const storyboardType = _.get(storyboard, 'type', '');
  const storyboardId = _.get(storyboard, 'id', null);
  const workspace = useSelector(state => _.get(state, 'workspaces.workspace.item', null));
  const superAdmin = _.get(workspace, 'superAdmin', false);

  const [state, setState] = useState({
    details: true,
    template: false,
    storyboardName:'Untitled-1',
    list: listId
  });

  const [selectedTemplate,setSelectedTemplate]= useState(defaultTemplate);

  useEffect(() => {
    setState({
      ...state,
      template: true,
      create: create,
      update: update,
      deleteModal: false
    });

    let type = ""

    dispatch(fetchCatgeoriesAndIndustries())

    if(create){
      type = storyboardType
    }

    if (show) {
      let request = {
        type: type, category: "", industry: "", sort: "created_date", order: "DESC", superAdmin: superAdmin
      }
      dispatch(fetchTemplates(0, 20, request ));
    } else {
      setState({
        details: true,
        template: false,
        storyboardName:'Untitled-1',
        list: listId
      })
    }

    setStoryboardState && setStoryboardState({
        content: null,
        storyboardName: state?.storyboardName
      });
  }, [show]);

  const handleNameChange = (e) => {
    var name = e.target.value;

    setState(state => {
      return {
        ...state,
        storyboardName: name
      }
    });
    setStoryboardState && setStoryboardState((state) => {
      return {
        ...state,
        storyboardName: name
      }
    });
  }

  const handleView = (value) => {
    setState(state => {
      return {
        ...state,
        ...value
      }
    });
  }

  const handleClose = () =>{
    setState({
      ...state,
      storyboardName:'Untitled-1',
      template: false
    });

    setSelectedTemplate(defaultTemplate)
    onClose()
  }

  const handleSaveTemplate = () => {
    setState(state => {
      return {
        ...state,
        storyboardName: "Untitled-1"
      }
    });

    if(selectedTemplate && selectedTemplate.selected){
      var request = {
        name: selectedTemplate.name,
        categories: selectedTemplate.categories,
        industries: selectedTemplate.industries,
        storyboard: storyboardId,
        template: selectedTemplate.id
      }
      dispatch(updateTemplate(request));

      if(!state.update){
        handleClose();
      }else{
        handleView({update: false})
      }
      
      return;
    }else{
      var request = {
        name: selectedTemplate.name,
        categories: selectedTemplate.categories,
        industries: selectedTemplate.industries,
        storyboard: storyboardId
      }
      dispatch(createTemplate(request))
    }

    handleClose();
  }

  const handleCreateStoryboard = (template) => {
    var templateUrl = `${baseUrl}/storyboards/templates/${template.id}/create?name=${state.storyboardName}`;

    if(listId) {
       templateUrl = `${templateUrl}&list=${listId}`;
    }

    const win = window.open(templateUrl, "_blank");
    win.focus();
    handleClose();
  }

  return (
    <>
      <Offcanvas className={cx(styles.createStoryboard, {
        [styles.fullscreen]: state.template
      })} show={show && state.template} placement="end">
        <TemplateView 
          storyboardName={state.storyboardName} 
          storyboardType={storyboardType} 
          onBack={() => {handleClose()}} 
          onNameChange={handleNameChange} 
          onFinish={handleCreateStoryboard} 
          create={create} 
          update={state.update} 
          showDeleteModal={state.deleteModal} 
          selectedTemplate={selectedTemplate} 
          setSelectedTemplate={setSelectedTemplate} 
          onTemplateSave={handleSaveTemplate} 
          handleView={handleView}
          updateProperty={updateProperty}
          setPptState={setPptState}
          setCreateState={setCreateState}
          storyboardState={storyboardState}
          setStoryboardState={setStoryboardState}
        />
      </Offcanvas>
    </>
  );
}


export function TemplateView({ 
  onBack, 
  onFinish, 
  storyboardName, 
  storyboardType, 
  onNameChange, 
  create, 
  update, 
  showDeleteModal, 
  selectedTemplate, 
  setSelectedTemplate, 
  onTemplateSave, 
  handleView,
  updateProperty,
  setPptState,
  setCreateState,
  storyboardState,
  setStoryboardState
}) {
  const dispatch = useDispatch();
  const { boot, show } = useIntercom();
  const [showImportDropdown, setShowImportDropdown] = useState(false);
  const [hideTimeout, setHideTimeout] = useState(null);

  const loading = useSelector(state => _.get(state, 'templates.loading',false));
  const updating = useSelector(state => _.get(state, 'templates.updating',false));
  const deleting = useSelector(state => _.get(state, 'templates.deleting',false));
  const templates = useSelector(state => _.get(state, 'templates.items'));
  const pagination = useSelector(state => _.get(state, 'templates.pagination'));

  const hasMoreItems = _.get(pagination, "current") < _.get(pagination, "totalPages") - 1;

  const [contentType, setContentType] = useState("");
  const [categoryTypes, setCategoryTypes] = useState([{ type: "All Templates", value: "" }]);
  const [industryTypes,setIndustryTypes] = useState([{ type: 'All', value: "" }]);
  const [selectedFilters,setSelectedFilters] = useState({contentType: "", categoryType: "", industryType: "", sortType: "created_date", sortOrder: "DESC"});

  const [newStoryboardConfig, setNewStoryboardConfig] = useState({});

  const subscription = useSelector(state => _.get(state, 'workspaces.workspace.item.subscription'));
  const user = useSelector((state) => _.get(state, "users.me"));

  const workspace = useSelector(state => _.get(state, 'workspaces.workspace.item', null));
  const superAdmin = _.get(workspace, 'superAdmin', false);

  const defaultTemplate = {
    selected: false,
    name: "Untitled-1",
    categories: [],
    industries: []
  }

  const isPPTSupportType = _.includes(["INTERACTIVE_CONTENT", "SPATIAL"], selectedFilters?.contentType);
  const isFigmaSupportType = _.includes(["INTERACTIVE_CONTENT", "LANDING_PAGE", "RESOURCE_CENTER"], selectedFilters?.contentType);

  const contentTypeOptions = [
    { 
      id: 'blank_interactive_template',
      filterName: "contentType",
      filterValue: "INTERACTIVE_CONTENT",
      label: "Interactive Content",
      image: "/images/interactive.svg",
      active: "/images/interactive_active.svg",
      className: "interactiveImg",
      enabled: _.get(subscription, 'interactiveContentEnabled', false)
    },
    {
      id: 'blank_landing_page_template',
      filterName: "contentType",
      filterValue: "LANDING_PAGE",
      label: "Landing Page",
      image: "/images/landing.svg",
      active: "/images/landing_active.svg",
      className: "landingImg",
      enabled: _.get(subscription, 'landingPageEnabled', false)
    },
    {
      id: 'blank_resource_center_template',
      filterName: "contentType",
      filterValue: "RESOURCE_CENTER",
      label: "Resource Center",
      image: "/images/resource.svg",
      active: "/images/resource_active.svg",
      className: "resourceImg",
      enabled: _.get(subscription, 'resourceCenterEnabled', false)
    },
    { 
      id: 'blank_spatial_template',
      filterName: "contentType",
      filterValue: "SPATIAL",
      label: "Spatial Content",
      image: "/images/spatial.svg",
      active: "/images/spatial_active.svg",
      className: "interactiveImg",
      enabled: _.get(subscription, 'spatialEnabled', false)
    }
  ];

  const sortByOptions = [
    {
      type: 'Name',
      value: 'Name'
    },
    {
      type: 'Date',
      value: 'created_date'
    }
  ]

  const loadMoreTemplates = () => {
    const nextPage = pagination.current + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    handleFetchTemplates(nextPage);
  }

  const handleFetchTemplates = (page) => {
    let type = selectedFilters.contentType

    if(create){
      type = storyboardType
    }

    let request = {
       type: type, 
       category: selectedFilters.contentType !== "RESOURCE_CENTER" ? selectedFilters.categoryType : "", 
       industry: selectedFilters.industryType, 
       sort: selectedFilters.sortType, 
       order: selectedFilters.sortOrder,
       superAdmin: superAdmin
    }

    dispatch(fetchTemplates(page, 20, request));
  }

  const initializeIntercom = () => {

    boot({
      appID: INTERCOM_ID,
      name: `${user.firstName} || '' ${user.lastName} || ''`,
      userId: `${user.email}`,
      email: `${user.email}`,
      hideDefaultLauncher: true,
    })
  }

  useEffect(() => {
    setStoryboardState && setStoryboardState((state) => {
      return {
        ...state,
        storyboardName: storyboardName || ""
      }
    });
    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_TEMPLATES)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
  }, [])

  useEffect(() => {
    if (user) {
      initializeIntercom();
    }
  }, [user]);

  useEffect(()=>{
    handleFetchTemplates(0);
  },[selectedFilters])

  useEffect(() => {
    fetchCategoryOptions();
    fetchIndustriesOptions();
  }, [templates]);

  useEffect(() => {
    if(storyboardType){
      const option = contentTypeOptions.find(option => option.filterValue === storyboardType);
      const type = _.get(option, 'label', 'All');
      setContentType(type)
    }
  }, [storyboardType]);

  const fetchCategoryOptions = () => {
      var templateCategories = templates.map(template => {

          if(template.categories && template.categories.length != 0){
            let categoryItems = template.categories.map((category)=>{
                  if(category && category.length != 0){
                    return{ type: category, value: category };
                  }
            })
            return categoryItems;
          }    
      })

      var data = _.compact(templateCategories).flat();

      data = [
        ...categoryTypes,
        ...data
      ]

      data = _.uniqBy(data, 'type');
      setCategoryTypes(data);
  }

  const fetchIndustriesOptions =()=>{
      var industryList = templates.map(template => {
        if(template.industries && template.industries.length != 0){
          let industryOptions = template.industries.map((industry)=>{
                if(industry && industry.length != 0){
                  return{ type: industry, value: industry };
                }
          })
          return industryOptions;
        }    
      })

      var data = _.compact(industryList).flat();

      data = [
        ...industryTypes,
        ...data
      ]

      data = _.uniqBy(data, 'type');
      setIndustryTypes(data);
  }

  const handleContentTypeChange = (option) => {

    const { id, filterName, filterValue, label } = option;

    setStoryboardState && setStoryboardState((state) => {
      return {
        ...state,
        content: option,
      }
    });
    
    if(!_.isEqual(filterValue, selectedFilters.contentType)){
      setNewStoryboardConfig({id: id});
      onFilterChange(filterName, filterValue);
      setContentType(label);
    }
    else{
      setNewStoryboardConfig({});
      onFilterChange(filterName, '');
      setContentType('All');
    }
  }

  const handleCreateTemplate = (useTemplate) => {
    onFinish(useTemplate || newStoryboardConfig);
  }

  const onClickOutsideListener = () => {
    document.removeEventListener("click", onClickOutsideListener)
  }

  const handleCancel = () => {
    onBack()
    let request={
      type: "", category: "", industry: "", sort: "created_date", order: "DESC", superAdmin: superAdmin
    };
    dispatch(fetchTemplates(0, 20, request));

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_MY_STORYBOARD, workspace.id, workspace.name);
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload));
  }

  const RenderTemplateType = ({type}) => {
    var templateType = null;
    var contentData = type.replaceAll('_', ' ').toLowerCase();

    switch (type) {
      case 'INTERACTIVE_CONTENT':
        templateType=(
          <div className={styles.templateTypeWrapper}>
            <i className={cx("cleverstory-Interactive")} />
            <span className={styles.contentType}>{contentData}</span>
          </div>
        )
        break;

      case 'LANDING_PAGE':
          templateType=(
            <div className={styles.templateTypeWrapper}>
              <i className={cx("cleverstory-landing-page")} />
              <span className={styles.contentType}>{contentData}</span>
            </div>
          )
        break;  

      case 'RESOURCE_CENTER':
          templateType=(
            <div className={styles.templateTypeWrapper}>
              <i className={cx("cleverstory-resource-center")} />
              <span className={styles.contentType}>{contentData}</span>
            </div>
          )
        break;
        
        case 'SPATIAL':
        templateType=(
          <div className={styles.templateTypeWrapper}>
            <i className={cx("cleverstory-slide-background")} />
            <span className={styles.contentType}>{`${contentData} Content`}</span>
          </div>
        )
        break; 
    
      default: templateType=(<div></div>)
        break;
    }

    return templateType;
  }

  const CustomFilterDropdown = React.forwardRef(({ children, onClick }, ref) => (
    <span
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={styles.dropDownToggle}
    >
      {children}
      <i className={cx('cleverstory-drop-down')}/>
    </span>
  ));

  const CustomDropdown = ({dropdownName, filterType, filterOptions, selectedFilterType, sortOrder}) =>{
    return(
        <aside className={styles.filterContainer}>
          <label className={styles.filterLabel}>{dropdownName} 
              {sortOrder && <img onClick={()=>onFilterChange("sortOrder",selectedFilters.sortOrder === "ASC" ? "DESC" : "ASC")} className={cx(styles.sortIcon, selectedFilters.sortOrder === "ASC" ? styles.ascending : styles.descending)} alt="sortIcon" src='/images/sortIcon.svg' data-track-event="Mixpanel" data-track-props="Sort Template"/>} 
          </label>
          <Dropdown className={styles.storboardTypeDropdown} data-track-event="Mixpanel" data-track-props={dropdownName === "Industry:" ? "Industry filter" : "Sort Template"}>
            <Dropdown.Toggle as={CustomFilterDropdown} id="dropdown-custom-components">
              { 
                filterOptions.map((option)=> {
                    if(option.value == selectedFilterType){
                        return option.type
                    }
                })
              }
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                filterOptions.map((option, index)=> {
                  return (
                    <Dropdown.Item active={option.value == selectedFilterType} onClick={ ()=>onFilterChange(filterType,option.value) }  key={index} eventKey={index}>{option.type}</Dropdown.Item>
                  )
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </aside>
    )
  }

  const onFilterChange = (type, value) => {
    setSelectedFilters((state) => {
      return {
        ...state,
        [type]: value,
      };
    });
  };

  const handleTemplateCardClick = (template) => {
    if(!create){
      return;
    }

    if(template == ''){
      setSelectedTemplate(defaultTemplate)
    }

    if(template.id === selectedTemplate.id){
      setSelectedTemplate(defaultTemplate)
    }else{
      template.selected = true
      setSelectedTemplate(template)
    }
  }

  const handleUpdateTemplateClick = (template) => {
    template.selected = true
    setSelectedTemplate(template)
    handleView({update: true})
  }

  const handleDeleteTemplateClick = (template) => {
    template.selected = true
    setSelectedTemplate(template)
    handleView({deleteModal: true})
  }

  const handleDeleteTemplate = (template) => {
    dispatch(deleteTemplate(template))
    setSelectedTemplate(defaultTemplate)
    handleView({deleteModal: false})
  }

  const handleCancelDeleteClick = (template) => {
    setSelectedTemplate(defaultTemplate)
    handleView({deleteModal: false})
  }

  const handleEnableClick = (template) => {
    dispatch(updateTemplateVisibility(template.id, !template.enabled))
  }

  const importDropdown = React.forwardRef(({ children, onClick }, ref) => (
    <Button variant="primary"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={cx(styles.dropDownToggle, { [styles.active] : showImportDropdown, [styles.disabled] : (selectedFilters.contentType === '' ||  storyboardName?.trim() === '')})}
    >
      {children}
    </Button>
  ));

  const handleMouseEnter = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }
    if (selectedFilters.contentType !== '' &&  storyboardName?.trim() !== '') {
      setShowImportDropdown(true);
    }  
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
        setShowImportDropdown(false);
    }, 300);
    setHideTimeout(timeout);
  };

  return (
    <section className={styles.storyboardTemplates} >
      <DeleteModal deleteModal={showDeleteModal} handleCancel={handleCancelDeleteClick} onDelete={handleDeleteTemplate} template={selectedTemplate}></DeleteModal>
      <Row className={styles.row}>
        <EditView onBack={onBack} onFinish={onFinish} onNameChange={onNameChange} selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} onTemplateSave={onTemplateSave} create={create} update={update} handleView={handleView}></EditView>
          <Col className={styles.sidePanel} xs='5' lg='4'>
          <Button className={styles.backButton} variant="info" onClick={handleCancel} >
            <i className={cx("cleverstory-close")} />
          </Button>
          <header className={styles.header}>
            <h1 className={styles.title}>Create New Storyboard</h1>
            <span className={styles.description}>Select a template from the library or create <br></br> something from scratch.</span>
          </header>
          <div className={styles.blankTemplate}>
            <div className={styles.customContainer}>
                <h6 className={styles.typesTitle}>TITLE</h6>
                <Form.Control
                  value={storyboardName}
                  onChange={onNameChange}
                  className={styles.name}
                  placeholder="Storyboard name"
                  data-track-event="Mixpanel" data-track-props="Title in Template"
                />
            </div>

            <div className={styles.customContainer}> 
                <h6 className={styles.typesTitle}>CONTENT TYPE</h6>     
                <div className={styles.storyBoardFormat} >

                {contentTypeOptions.map((option)=> {
                    return(
                      <>
                      {option.enabled &&
                        <Button variant="info" className={cx(styles.scratchTemplate, { [styles.activeBtn]: selectedFilters.contentType === option.filterValue })} onClick={() => handleContentTypeChange(option)} data-track-event="Mixpanel" data-track-props={
                          {
                            INTERACTIVE_CONTENT: "IC Template",
                            LANDING_PAGE: "LP Template",
                            RESOURCE_CENTER: "RC Template",
                            SPATIAL: "Spatial Template",
                          }[option.filterValue] || ""
                        }>
                          <div className={styles.imgBox}>
                            <img className={styles[option.className]} src={selectedFilters.contentType === option.filterValue ? option.active : option.image} />
                          </div>
                          <div className={styles.titleBox}>
                            <span>{option.label}</span>
                          </div>
                        </Button>
                      }
                      </>
                    )
                  })
                }
                </div>
            </div>
            
            {selectedFilters && selectedFilters.contentType === 'RESOURCE_CENTER' ? 
                <>
                  <div className={styles.customContainer}>
                      <h6 className={styles.typesTitle}>INDUSTRY</h6>
                      <div className={styles.templateTypes}>
                        <div className={styles.listView}>
                          {
                            (industryTypes || []).map((data, id) => {
                              const active = _.isEqual(data.value, selectedFilters.industryType);
                              return (
                                <Button variant="light" key={id} onClick={() => onFilterChange('industryType', data.value)} className={cx(styles.templateList, { [styles.active]: active })}>{data.type}</Button>
                              )
                            })
                          }
                        </div>
                      </div>
                  </div>
                </>
                :
                <>
                  <div className={styles.customContainer}>
                      <h6 className={styles.typesTitle}>USE CASE</h6>
                      <div className={styles.templateTypes}>
                        <div className={styles.listView}>
                          {
                            (categoryTypes || []).map((data, id) => {
                              const active = _.isEqual(data.value, selectedFilters.categoryType);
                              const newTemplate = ["Holiday Promo"];
                              return (
                                <Button variant="light" key={id} data-track-event="Mixpanel" data-track-props="Usecase Template" onClick={() => onFilterChange('categoryType', data.value)} className={cx(styles.templateList, { [styles.active]: active })}>{data.type} {_.includes(newTemplate, data.type) && (
                                  <span className={styles.newLabel}>NEW</span>
                                )}</Button>
                              )
                            })
                          }
                        </div>
                      </div>
                  </div>
                </>
            }
            <div className={styles.createButtonContainer}>
              <Button className={cx(styles.createButton,{[styles.disabled] : (selectedFilters.contentType === '' || storyboardName?.trim() === '')})} onClick={() => handleCreateTemplate()} variant="light">
                <i className='cleverstory-plus' /> Create from scratch
              </Button>

              {userRoleService.canCreateStoryboard() &&
                <>
                  <Dropdown 
                    className={styles.importDropdown} 
                    show={showImportDropdown} 
                    onMouseEnter={handleMouseEnter} 
                    onMouseLeave={handleMouseLeave}
                  >
                    <Dropdown.Toggle as={importDropdown} className={cx(styles.importButton)}>
                      <i className={cx('cleverstory-import')} />Import Design
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                    {subscription.interactiveContentEnabled &&
                      <Dropdown.Item disabled={!isPPTSupportType} data-track-event="Mixpanel" data-track-props="PPT Import from Template">
                        <PPTXButton 
                          setPptState={setPptState} 
                          setCreateState={setCreateState} 
                          storyboardState={storyboardState} 
                          setStoryboardState={setStoryboardState}
                          createDirectly={true}
                          className={styles.pptxButton}
                        />
                      </Dropdown.Item>
                    }
                      <Dropdown.Item onClick={()=>updateProperty('showLinkModal', true)} disabled={!isFigmaSupportType} data-track-event="Mixpanel" data-track-props="Figma Import from Template">
                        <i className={cx('cleverstory-figma')} />Figma
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              }
            </div>
          </div>
        </Col>
        
        
        <Col className={styles.templatesPane} xs='7' lg='8'>
          <div className={styles.headerContainer}>
              <div>
                <h4 className={styles.mainHeading}>{contentType ? contentType : "All"}</h4>
                <h4 className={styles.heading}>Templates</h4>
              </div>

              <div className={styles.filtersContainer}>
                {selectedFilters.contentType !== 'RESOURCE_CENTER' && 
                    <CustomDropdown dropdownName="Industry:" filterOptions={industryTypes} filterType="industryType" selectedFilterType={selectedFilters.industryType}/>
                }
                <CustomDropdown dropdownName="Sort By:" filterOptions={sortByOptions} filterType="sortType" selectedFilterType={selectedFilters.sortType} sortOrder={selectedFilters.sortOrder}/>
              </div>
              <div className={styles.helpButtonContainer}>
                <Button size='sm' variant='primary' onClick={show} className={styles.helpButton} data-track-event="Mixpanel" data-track-props="Help from Template">
                  <i className={cx(styles.helpIcon, "cleverstory-support-help")} />
                  Help
                </Button>
              </div>
          </div>

          {((loading && templates.length === 0) || updating) &&
            <Loader className={styles.loadingAnimation} title="Loading templates..." />
          }

          {deleting &&
            <Loader className={styles.loadingAnimation} title="Deleting template..." />
          }

          {templates.length > 0 && !updating && !deleting &&
            <InfiniteScroll
              className={styles.templates}
              loading={loading}
              hasMore={hasMoreItems}
              loadMore={() => {
                loadMoreTemplates();
              }}>

                {templates.map(template => {
                  const icon = _.get(template, 'icon.url');
                  const liveSite = _.get(template, 'url');
                  const isActive = selectedTemplate.id === template.id;

                  return (
                    <div key={template.id} 
                    className={cx(styles.template,{ [styles.active]: isActive })}
                      onClick={() => handleTemplateCardClick(template)}
                    >
                      {!create && superAdmin && !update &&
                        <div className={cx(styles.templateToggle,{ [styles.enabled]: !template.enabled })}>
                          <Form.Switch className={cx(styles.downloadSwitch)}>
                            <Form.Switch.Label className={styles.label}>
                              {template.enabled ? 'Enabled' : 'Disabled' }
                            </Form.Switch.Label>
                            <Form.Switch.Input
                              onClick={() => handleEnableClick(template)}
                              className={styles.toggleButton}
                              checked={template.enabled}
                            />
                          </Form.Switch>
                        </div>
                      }
                      <div 
                      className={cx(styles.innerContainer,{ [styles.disabled]: superAdmin && !template.enabled })}
                      >
                          {icon &&
                            <IKImage
                              className={styles.icon}
                              path={icon}
                              transformation={[{
                                "width": "600"
                              }]}
                            />
                          }
                          {!icon &&
                            <img className={styles.icon} src={'/images/storyboard.png'} alt="" />
                          }
              
                          <div className={styles.details} >
                            <div className={styles.top}>
                              <span className={styles.title}><LinesEllipsis text={template.name} maxLine='2' ellipsis='...' /> </span>
                            </div>

                            <div>
                                <div className={styles.badgeContainer}>
                                  {
                                    template.type !== 'RESOURCE_CENTER' && template.categories && template.categories.map((category,index,categoriesAll)=>{
                                      if(index < 2){
                                        return <label className={cx(styles.badges,styles.categories)}>{category}</label>
                                      }
                                      else if(index == 2){
                                        return <label className={cx(styles.badges,styles.categories)}>{`+${categoriesAll.length - 2}`}</label>
                                      }
                                    })
                                  }
                                </div>

                                <div className={styles.badgeContainer}>
                                  {
                                      template.industries && template.industries.map((industry,index,industryAll)=>{
                                        if(index < 2){
                                          return <label className={cx(styles.badges,styles.industries)}>{industry}</label>
                                        }
                                        else if(index == 2)
                                          return <label className={cx(styles.badges,styles.industries)}>{`+${industryAll.length - 2}`}</label>
                                      })
                                    }
                                </div>
                            </div>
                            
                            <div className={styles.actions}>
                              <RenderTemplateType type={template.type}/>
                              <div className={styles.buttonsContainer}>
                                {(!create && !update) &&
                                  <Tooltip placement="top" content="Edit">
                                   <Button variant="info" className={styles.actionButton} onClick={() => handleCreateTemplate({id: template.id})} disabled={storyboardName?.trim() === ''} data-track-event="Mixpanel" data-track-props="Edit Template">
                                     <i className={cx("cleverstory-edit")} />
                                   </Button>
                                  </Tooltip>
                                }

                                {liveSite && <Tooltip placement='top' content='Preview'>
                                  <Button variant="info" onClick={() => window.open(liveSite, '_blank')} data-track-event="Mixpanel" data-track-props="Preview Template">
                                    <i className={cx("cleverstory-view")} />
                                  </Button>
                                </Tooltip>}

                                {(!create && !update && superAdmin) &&
                                <OverlayTrigger
                                  rootClose={true}
                                  rootCloseEvent="mousedown"
                                  key={template.id}
                                  trigger="click"
                                  placement="bottom"
                                  overlay={
                                    <Popover className={styles.storyboardCardMoreAction} id="popover-basic">
                                      <ListGroup>
                                        <ListGroup.Item onClick={() => handleUpdateTemplateClick(template)} className={styles.storyboardCardMoreList}>
                                        <i className={cx("cleverstory-edit")}/>   Edit Details</ListGroup.Item>
                                        <ListGroup.Item onClick={()=>handleDeleteTemplateClick(template)} className={styles.storyboardCardMoreList}>
                                          <i className={cx("cleverstory-trash")}/> Delete</ListGroup.Item>
                                      </ListGroup>
                                    </Popover>
                                  }
                                >
                                  <Button variant="info">
                                    <i className={cx("cleverstory-more", styles.iconMore)}/>
                                  </Button>
                                </OverlayTrigger>
                                }

                              </div>
                            </div>
                          </div>
                          <div key={template.id} className={styles.viewOverlay}>
                            <Button className={styles.viewButton} onClick={() => window.open(liveSite, '_blank')} variant="primary">Preview</Button>
                            <Button className={styles.editButton} onClick={() => handleCreateTemplate({id:template.id})} variant="primary" disabled={storyboardName?.trim() === ''}>Edit</Button>
                          </div>
                      </div>
                    </div>
                  )
                })}
            </InfiniteScroll>
          }

          {!loading && templates.length === 0 &&
              <div className={styles.emptyMessageContainer}>
                  <div className={styles.emptyMessage}>
                    <Image className={styles.emptyImage} src="/images/emptyUser.png" />
                    <div className={styles.errorMessageContent}>
                      <div className={styles.errorMessageTitle}>
                        <h2>No man<span>,</span><br /></h2>
                        <h2>No mouse<span>,</span><br /></h2>
                      </div>
                      <div className={styles.errorMessageSubText}>
                        <span>It's an empty<br />house.<br /></span>
                      </div>
                      <Button
                        type="submit"
                        variant="primary"
                        className={styles.inviteButton}
                        onClick={()=>{ setSelectedFilters({contentType: "", categoryType: "", industryType: "", sortType: "created_date", sortOrder:"DESC" }) }}
                      >
                        Reset Filters
                      </Button>
                    </div>
                  </div>
              </div>
          }
        </Col>
      </Row>
    </section>
  )
}

export function EditView({ onBack, onTemplateSave, onNameChange, selectedTemplate, setSelectedTemplate, create, update, handleView }) {
  const dispatch = useDispatch();

  const storyboard = useSelector(state => _.get(state, 'storyboards.storyboard.item', {}));
  const storyboardType = _.get(storyboard, 'type', '');

  const categories = useSelector(state => _.get(state, 'templates.categories'));
  const industries = useSelector(state => _.get(state, 'templates.industries'));

  let categoryTags = _.map(selectedTemplate.categories, category => ({
    value: category,
    label: category
  }));

  let industryTags = _.map(selectedTemplate.industries, industry => ({
    value: industry,
    label: industry
  }));

  let allCategoryTags = _.map(categories, category => ({
    value: category,
    label: category
  }));

  let allIndustryTags = _.map(industries, industry => ({
    value: industry,
    label: industry
  }));

  const onClickOutsideListener = () => {
    setSelectedTemplate(defaultTemplate)
    document.removeEventListener("click", onClickOutsideListener)
  }

  const handleCancel = () => {
    if(update){
      handleView({update: false})
      setSelectedTemplate(defaultTemplate)
      return;
    }

    onBack()
  }

  const handleSaveClick = () => {
    setSelectedTemplate(defaultTemplate)
    onTemplateSave();
  }

  const handleCategoryClick = (tags) => {
    if (!tags) {
      return;
    }
    const updatedTags = _.map(tags, (data) => {
      return data.value;
    });
    setSelectedTemplate(prevState => ({
      ...prevState,
      categories: updatedTags
    }));
  } 

  const handleIndustryClick = (tags) => {
    if (!tags) {
      return;
    }
    const updatedTags = _.map(tags, (data) => {
      return data.value;
    });

    setSelectedTemplate(prevState => ({
      ...prevState,
      industries: updatedTags
    }));
  } 

  const handleNameChange = (e) => {
    const name = e.target.value;

    if(create){
      setSelectedTemplate(prevState => ({
        ...prevState,
        selected: false,
        name: name,
        id: null
      }));
    }else{
      setSelectedTemplate(prevState => ({
        ...prevState,
        name: name,
      }));
    }
  
    onNameChange(e);
  };

  const selectCustomStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#212121;',
      borderColor: state.isFocused ? 'var(--saveButtonColor);' : 'var(--HeadingColor);',
      borderRadius: '22px',
      color: 'white',
      fontSize: '.875em',
      minHeight: '40px',
      '&:hover': {
        borderColor: 'var(--saveButtonColor);',
      },
      boxShadow: state.isFocused ? '0 0 0 1px var(--saveButtonColor);' : 'none',
    }),

    input: (provided) => ({
      ...provided,
      color: 'white',
    }),

    option: (provided, state) => ({
      ...provided,
      boxShadow: 'none',
      backgroundColor: '#2C2C2C',
      color: '#9E9E9E',
      fontSize: '.875em',
      transition: 'background-color 0.2s ease, color 0.2s ease',

      '&:hover': {
        boxShadow: 'none',
        backgroundColor: '#212121',
        color: 'white'
      },
    }),
    
    placeholder: (provided) => ({
      ...provided,
      color: 'grey',
      fontSize: '.875em',
    }),

    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),

    multiValue: (provided) => ({
      ...provided,
      borderRadius: '20px',
      backgroundColor: '#2C2C2C',
      paddingRight: '4px',
    }),

    multiValueLabel: (provided) => ({
      ...provided,
      color: 'white',
    }),

    multiValueRemove: (provided, state) => {
      const isVisible = state.selectProps.menuIsOpen || state.selectProps.inputValue;
      return {
        ...provided,
        color: '#9E9E9E',
        borderRadius: '20px',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'scale(1)' : 'scale(0)',
        width: isVisible ? provided.width : 0,
        transformOrigin: 'center right',
        pointerEvents: isVisible ? 'auto' : 'none',
        marginLeft: isVisible ? provided.marginLeft : 0,
        marginRight: isVisible ? provided.marginRight : 0,
        paddingLeft: isVisible ? provided.paddingLeft : 0,
        paddingRight: isVisible ? provided.paddingRight : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out, width 0.3s ease-in-out, margin 0.3s ease-in-out, padding 0.3s ease-in-out',
        '&:hover': {
          backgroundColor: '#2C2C2C',
          color: 'white',
        },
      };
    },

    menu: (provided) => ({
      ...provided,
      border: 'none',
      borderRadius: '20px',
      backgroundColor: '#2C2C2C',
      fontSize: '.875em',
    }),

    menuList: (provided) => ({
      ...provided,
      border: 'none',
      borderRadius: '20px',
      backgroundColor: '#2C2C2C',

    }),

    menuPortal: (provided) => ({
      ...provided,
      border: 'none',
      borderRadius: '20px',
      backgroundColor: '#2C2C2C',
    }),

    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: '.875em',
    }),

    indicatorSeparator: (provided) => ({
      display: 'none',
    }),

    dropdownIndicator: (provided) => ({
      display: 'none',
    }),
  };

  return (
      <Col 
      className={cx(styles.sidePanelUpdate,{ [styles.active]: update || create })}
      xs='5' lg='4'>
        <Button className={styles.backButton} variant="info" onClick={handleCancel} >
          <i className={cx("cleverstory-close")} />
        </Button>
        <header className={styles.header}>
          <h1 className={styles.title}>{update ? 'Template Details' : create ? 'Save as a Template' : 'Save as a Template'}</h1>
          <span className={styles.description}>
            {update ? 'Modify the template metadata to ensure updates are reflected across the platform.' : 'Save as a template to the library and make it available across the platform.'}
          </span>
        </header>
        <div className={styles.blankTemplate}>
          <div className={styles.customContainer}>
            <div>
              <h6 className={styles.typesTitle}>TITLE</h6>
                <Form.Control
                  value={selectedTemplate.name}
                  onChange={handleNameChange}
                  className={styles.name}
                  placeholder="Storyboard name"
                  data-track-event="Mixpanel" data-track-props="Title in Template"
                />
            </div>
            {!(selectedTemplate.type === 'RESOURCE_CENTER' || storyboardType === 'RESOURCE_CENTER') &&
              <div>
                <h6 className={styles.typesTitle}>USE CASES</h6>
                  <CreatableSelect
                    styles={selectCustomStyles}
                    isClearable={false}
                    placeholder="Select Use Cases"
                    isMulti
                    value={categoryTags} 
                    onChange={handleCategoryClick}
                    options={allCategoryTags}
                  />
              </div>
            }
            <div>
              <h6 className={styles.typesTitle}>INDUSTRIES</h6>
              <CreatableSelect
                styles={selectCustomStyles}
                isClearable={false}
                placeholder="Select Industries"
                isMulti
                value={industryTags} 
                onChange={handleIndustryClick}
                options={allIndustryTags}
                />
            </div>
          </div>
          <div className={styles.saveChangesContainer}>
            <Button size='sm' variant='primary' onClick={handleSaveClick} className={styles.saveButton}>
            {update ? 'Save Changes' : create && selectedTemplate.selected ? 'Replace the Template' : 'Save as New Template'}
            </Button>
            <Button size='sm' variant='primary' onClick={handleCancel} className={styles.cancelButton}>
              Cancel
            </Button>
          </div>
        </div>
      </Col>
  )
}

const DeleteModal = ({ deleteModal, handleCancel, onDelete, template }) => {

  const id = _.get(template, 'id', null)
  const name = _.get(template, 'name', '')
  const deleting = useSelector(state => _.get(state, 'pages.deletion.deleting', false));
  const deleted = useSelector(state => _.get(state, 'pages.deletion.deleted', false));

  const handleDeleteClick = (e) => {
    onDelete(id);
    e.stopPropagation()
  }

  useEffect(() => {
    if (deleted) {
      handleCancel(false)
    }
  }, [deleted])

  return (
    <Modal
      className={styles.deleteTemplateModal}
      contentClassName={styles.deleteTemplateModalContent}
      dialogClassName={styles.deleteTemplateModalDialog}
      backdropClassName={styles.backdropWrapper}
      show={deleteModal}
      centered size="lg"
      onClick={(e) => { e.stopPropagation() }}
    >
      <Modal.Body className={styles.deleteTemplateModalBody}>
        <div className={styles.detailsContainer}>
          <div className={styles.messageContainer} >
            <Image src={'/images/deleteTemplate.png'} className={styles.deleteTemplateModalImage} />
            <h2 className={styles.messageTitle}>Are you sure you want to delete the '{name}' template?</h2>
            <p className={styles.messageContent}>
            Deleting this template will permanently remove it for all users across the product.
            </p>
            <footer className={styles.deleteTemplateModalButtons}>
              <Button variant="secondary" onClick={() => { handleCancel(false) }} >Cancel</Button>
              <Button variant="primary" onClick={handleDeleteClick} >{deleting ? 'Deleting...' : 'Delete'}</Button>
            </footer>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
